import localConfig from '@/config';

export const CHART_CONFIG = {
  colors: {
    grid: '#919191',
    axis: '#F8F8F8',
    primary: localConfig.isSynth ? '#F5F8C2' : '#DFFE00',
    tooltip: {
      background: '#272728',
      text: '#ADAEB1',
    },
  },
  gridRows: {
    opacity: 0.3,
    strokeWidth: 1,
  },
};
